import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./index.css";
import App from "./App";

// Determine environment
const environment = process.env.NODE_ENV || 'production';
const isDevelopment = environment === 'development';

// Support separate DSNs for production and development
// Falls back to single DSN if environment-specific DSN not set
const sentryDsn = isDevelopment 
  ? (process.env.REACT_APP_SENTRY_DSN_DEV || process.env.REACT_APP_SENTRY_DSN)
  : (process.env.REACT_APP_SENTRY_DSN_PROD || process.env.REACT_APP_SENTRY_DSN);

// Initialize Sentry for error monitoring
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Performance Monitoring - higher rate in development
    tracesSampleRate: isDevelopment ? 1.0 : 0.1,
    // Session Replay
    replaysSessionSampleRate: isDevelopment ? 0.5 : 0.1,
    replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors
    environment: environment,
    release: process.env.REACT_APP_VERSION || '1.0.0',
    debug: isDevelopment, // Enable debug mode in development
  });
  console.log(`Sentry initialized (environment: ${environment})`);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>An error has occurred. Please refresh the page.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
